import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=5af63f97&scoped=true&"
import script from "./EmailInput.vue?vue&type=script&lang=js&"
export * from "./EmailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af63f97",
  null
  
)

export default component.exports